import * as Types from "../../../store/actions/types";

const init = {
	data: {},
	pagination: {},
	isLoading: false,
	category: {
		data:[],
		pagination: {}
	},
	error: {},
};

const cardReducer = (state = init, action) => {
	switch (action.type) {
		case Types.CARD_IS_LOADING: {
			return {
				...state,
				isLoading: true
			};
		}
		case Types.CARD_RETRIEVE: {
			const isFirstPage = action.payload.page === 1;
			return {
				...state,
				data: isFirstPage 
				? action.payload.response.data || []
				: [...state.data, ...action.payload.response.data], 
				pagination: action.payload.response.pagination,
				isLoading: false
			};
		}
		case Types.CARD_CATEGORY_RETRIEVE: {
			const isFirstPage = action.payload.page === 1;
			return {
				...state,
				category: {
					data: isFirstPage 
					? action.payload.response.data || []
					: [...state.category.data, ...action.payload.response.data], 
					pagination: action.payload.response.pagination,
				},
				isLoading: false
			};
		}

		case Types.CARD_DELETE_ITEM : {
			const cardId = action.payload.id;
			return {
				...state,
					...state.data,
					data: state.data.filter(item => item.ID !== cardId),
				isLoading: false
			};
		}
		case Types.CARD_CATEGORY_DELETE : {
			const categoryId = action.payload.catId;
			return {
				...state,
				category: {
					...state.category,
					data: state.category.data.filter(item => item.id !== categoryId) 
				},
				isLoading: false
			};
		}
		case Types.CARD_SETTINGS_UPDATE: {
			const cardId = action.payload.cardId;
			const updatedSettingsData = action.payload.data.data;
			
			return {
				...state,
				data: Array.isArray(state.data) 
					? state.data.some(item => item.ID === cardId)
						? state.data.map(item => 
							item.ID === cardId 
								? { ...item, ...updatedSettingsData }
								: item
						)
						: [...state.data, updatedSettingsData]
					: [updatedSettingsData],
				isLoading: false
			};
		}
		case Types.CARD_CATEGORY_UPDATE : {
			const categoryId = action.payload.catId;
			const updatedTitle = action.payload.title;
			const updatedData = [action.payload.data];
			
			return {
				...state,
				category: {
					...state.category,
					data: (!Array.isArray(state.category.data) || state.category.data.length === 0) 
						? updatedData
						: state.category.data.map(item => 
							item.id === categoryId ? { ...item, title: updatedTitle } : item 
						)
				},
				isLoading: false
			};
		}
		case Types.CARD_CATEGORY_ADD_ITEM : {
			const categoryId = action.payload.catId;
			const categoryItem = action.payload.item;
			return {
				...state,
				category: {
					...state.category,
					data: state.category.data.map(item => 
						item.id === categoryId 
						? { 
							...item,
							items: item.items ? 
								item.items.some(existingItem => existingItem.id === categoryItem.id) 
								? item.items
								: [...item.items, categoryItem]
                        		: [categoryItem],
							itemCount: (item.items && item.items.some(existingItem => existingItem.id === categoryItem.id)) 
								? item.itemCount 
								: (item.itemCount || 0) + 1
						  } 
						: item 
					)
				},
				isLoading: false
			};
		}
		default:
			return {
				...state,
				isLoading: false
			}
	}
};

export default cardReducer;
